import { useState } from 'react';

import { EMPTY_ARRAY } from '@e-socna/empty';

import { Wizard } from '../../components/Wizard';

import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { useAddressSteps } from './hooks/useSteps.hook';
import type { AddressFormTab } from './enums/tab.enum';
import type { Props } from './types/props.type';

export const AddressForm = ({
  ValidationSchema,
  askMemoBeforeSubmit = true,
  config,
  formVariant,
  initialValues: pInitialValues,
  onCancel: handleCancel,
  onSubmit: handleSubmit,
  setMustBlockAction,
  showCancelButton,
  stepIdsSubset,
  title,
}: Readonly<Props>) => {
  const [enabledSteps, setEnabledSteps] =
    useState<readonly AddressFormTab[]>(EMPTY_ARRAY);

  const { initialValues } = useInitialValuesFactory(pInitialValues);

  const { steps, wizardChildren } = useAddressSteps({
    config,
    enabledSteps,
    setEnabledSteps,
    stepIdsSubset,
  });

  return (
    <Wizard
      ValidationSchema={ValidationSchema}
      askMemoBeforeSubmit={askMemoBeforeSubmit}
      formTitle={title}
      formVariant={formVariant}
      initialValues={initialValues}
      onCancel={handleCancel}
      onSubmit={handleSubmit}
      setMustBlockAction={setMustBlockAction}
      showCancelButton={showCancelButton}
      steps={steps}
    >
      {wizardChildren}
    </Wizard>
  );
};
